.backdrop {
  position: fixed;
  z-index: 20;
  display: grid;
  inset: 0;
  padding: var(--space-4);
  place-items: center;
  background: rgb(7 21 38 / 70%);
}

.dialog {
  inline-size: min(100%, 28rem);
  padding: var(--space-5);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-medium);
  color: var(--color-text);
  background: var(--color-surface);
  box-shadow: var(--shadow-preview);
}

.dialog h2,
.dialog p {
  margin: 0;
}

.dialog p {
  margin-block-start: var(--space-3);
  color: var(--color-text-muted);
  line-height: 1.55;
}

.actions {
  display: flex;
  gap: var(--space-2);
  justify-content: end;
  margin-block-start: var(--space-5);
}

.actions button {
  min-block-size: 2.75rem;
  padding-inline: var(--space-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-small);
  color: var(--color-text);
  background: var(--color-surface);
  font-weight: 750;
}

.actions .destructive {
  border-color: var(--color-danger);
  color: var(--white);
  background: var(--color-danger);
}

@media (max-width: 25rem) {
  .actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
}
